<template>
  <!-- Contact -->

  <div class="w-full flex flex-col justify-center items-center space-y-6">
    <div>
      <h1 class="text-expo_dblue mb-2 text-center">Get in touch</h1>
      <h5 class="text-center">
        Send a message directly to
        <span v-if="client === 'client1tenant'"
          >the advisor at {{ settings.profile_title }}</span
        >
        <span v-else>{{ settings.profile_title }}</span>
      </h5>
    </div>

    <div class="flex flex-col space-y-4 w-full lg:w-2/3">
      <!-- Name -->
      <div :class="inputWrapperClass" class="h-12">
        <h6 :class="inputLabelClass">Name</h6>
        <input
          id="name"
          v-model="name"
          type="text"
          name="name"
          autocomplete="name"
          :class="inputTextClass"
          @keyup="checkValidation"
          @change="checkValidation"
        />
      </div>
      <!-- /Name -->

      <!-- Email -->
      <div :class="inputWrapperClass" class="h-12">
        <h6 :class="inputLabelClass">Email</h6>
        <input
          id="email"
          v-model="email"
          type="email"
          name="email"
          autocomplete="email"
          :class="inputTextClass"
          @keyup="checkValidation"
          @change="checkValidation"
        />
      </div>
      <!-- /Email -->

      <!-- Comments -->
      <div :class="inputWrapperClass" class="h-24">
        <h6 :class="inputLabelClass">Message</h6>
        <textarea
          id="comments"
          v-model="comments"
          type="textarea"
          name="comments"
          autocomplete="comments"
          rows="2"
          :class="inputTextAreaClass"
        />
      </div>
      <!-- /Comments -->
    </div>

    <button
      :disabled="!canSubmit"
      :class="[
        !canSubmit ? 'opacity-25 cursor-not-allowed' : '',
        thinking ? '' : '',
      ]"
      class="btn btn-primary relative w-40"
      @click="contactExhibitor"
    >
      <div class="flex justify-center items-center w-full h-full">
        <div
          class="absolute inset-0 w-full flex justify-center items-center z-20"
        >
          <lottie v-if="thinking" :options="loadingAnimationOptions" />
        </div>
        <div
          :class="[thinking ? 'invisible' : '']"
          class="w-full flex items-center justify-center"
        >
          Submit
        </div>
      </div>
    </button>
  </div>
</template>

<script>
// @TODO VUE 3!
// This has already been rebuilt as part of layout 3 contact form
// Either port that component or at least use the store functions!

import { mapGetters } from 'vuex'
import { shared } from '../../js/mixins/shared.js'
import { EventBus } from '../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../shared/components/loading.json'

export default {
  mixins: [shared],

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      canSubmit: false,
      thinking: false,

      name: '',
      email: '',
      comments: '',

      currentYear: new Date().getFullYear(),

      inputWrapperClass:
        'rounded relative bg-white shadow border border-truegray-300 ',
      inputLabelClass:
        'absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-truegray-700',
      inputTextClass:
        'flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300',
      inputTextAreaClass:
        'flex-grow px-4 mr-0 mt-5 outline-none focus:outline-none bg-transparent h-18 font-primary text-black  focus:placeholder-truegray-300 transition-all duration-100 ease-in-out w-full',
      btnClass:
        'bg-black border-none flex justify-center items-center font-primary font-semibold py-0',
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
    }),
  },

  watch: {
    email: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'email', val)
      },

      deep: true,
    },
  },

  methods: {
    contactExhibitor() {
      // Disable the sign in button so that we do not interupt or clog up the call...
      this.$set(this, 'thinking', true)
      // Submit the access auth and kill the preloader...
      let current_tenant = this.settings.contact_email
      let current_client = this.client
      axios
        .post('/api/send-contact-form', {
          email: this.email,
          name: this.name,
          comments: this.comments,
          tenant: current_tenant,
          client: current_client,
        })
        .then((response) => {
          this.$set(this, 'thinking', false)
          // this.$set(this,'canSubmit',true);

          let returned = response.data

          if (returned.success) {
            this.$set(this, 'emailSubmitResponseSuccess', true)
            EventBus.$emit('triggerAlertResponse', {
              status: 'success',
              message: 'Your email has been sent. We will be in touch soon!',
            })
          } else {
            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }
          this.name = ''
          this.email = ''
          this.comments = ''
        })
    },

    checkValidation() {
      let canSubmit = true
      // Enable / dissable sign in button depending on the validity of the email they have provided
      if (!this.resetPassword) {
        if (!this.validateEmail(this.email) || this.name.length < 3) {
          canSubmit = false
        }
      } else {
        if (!this.validateEmail(this.email)) {
          canSubmit = false
        }
      }

      this.$set(this, 'canSubmit', canSubmit)
    },

    noemptychars: function (event) {
      if (event.keyCode === 32) {
        event.preventDefault()
      }
    },
  },
}
</script>
